import Start_Main_Start_BtnSection from "./Start_Main_Start_BtnSection";
import Start_Main_Start_SignIn from "./Start_Main_Start_SignIn";
import { Outlet } from "react-router-dom";
import React from "react";

class Start_Main_Start extends React.Component {
    render() {
        return(
            <div className="start_main_start">
                <h1 className="start_main_start_heading">Happening now</h1>
                <h2 className="start_main_start_join">Join dZen today.</h2>
                <Start_Main_Start_BtnSection />
                <Start_Main_Start_SignIn />
                <Outlet />
            </div>
        )
    }
}

export default Start_Main_Start;